'use client'

import { useInstantSearch } from 'react-instantsearch'

const AlgoliaEmptyQueryBoundary = ({ children, fallback }) => {
  const { indexUiState } = useInstantSearch()

  if (!indexUiState.query) {
    return fallback
  }

  return children
}

export default AlgoliaEmptyQueryBoundary
